/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

import {
	DpAccordion,
	DpAccordionDetails,
	DpAccordionFrame,
	DpAccordionSummary,
} from '@/components/blocks/DpAccordion';
import {
	DpArticleContainer,
	DpArticleContent,
	DpArticleContentFrame,
	DpArticleContentTitle,
	DpArticleHeader,
	DpArticleHeaderBack,
	DpArticleHeaderCategory,
	DpArticleText,
	DpArticleTitle,
} from '@/components/blocks/DpArticle';
import {
	DpArticleCard,
	DpArticleCardEmphasis,
	DpArticleCardGrid,
	DpArticleCardText,
} from '@/components/blocks/DpArticleCard';
import { DpBlogCard } from '@/components/blocks/DpBlogCard';
import { DpBlogGrid } from '@/components/blocks/DpBlogGrid';
import { DpBorderRefunds } from '@/components/blocks/DpBorderRefunds';
import { DpBannerAds, DpPlpBannerAds } from '@/components/blocks/DpLibrary/DpBannerAds';
import { DpBannerAdsText } from '@/components/blocks/DpLibrary/DpBannerAdsText';
import { DpBestOffer } from '@/components/blocks/DpLibrary/DpBestOffer';
import { DpButton } from '@/components/blocks/DpLibrary/DpButton';
import { DpCardCategory } from '@/components/blocks/DpLibrary/DpCardCategory';
import { DpCardTendence } from '@/components/blocks/DpLibrary/DpCardTendence';
import { DpCarouselContent } from '@/components/blocks/DpLibrary/DpCarouselContent';
import { DpMark } from '@/components/blocks/DpLibrary/DpMark';
import { ContentMostNew } from '@/components/content/ContentMostNew';
import { Linkable } from '@/components/blocks/Linkable';
import { Img } from '@/components/blocks/MaterialImage';
import {
	Box,
	Button,
	Container,
	Grid,
	List,
	ListItem,
	MenuItem,
	Paper,
	Stack,
	Typography,
} from '@mui/material';
import { OverridableComponent } from '@mui/material/OverridableComponent';
import { FC } from 'react';
import { DpPromotionImage } from '@/components/blocks/DpLibrary/DpPromotionImage';
import { DpBannerCheckout } from '@/components/blocks/DpLibrary/DpBannerCheckout';
import { DpCatalogEntryCarouselHeader } from '@/components/blocks/DpLibrary/DpCatalogEntryCarouselHeader';
import { DpProductGridCard } from '@/components/blocks/DpLibrary/DpProductGridCard';
import { DpTitles } from '@/components/blocks/DpLibrary/DpTitles';
import { DpSEOFrame } from '@/components/blocks/DpLibrary/DpSEOFrame';
import { DpSEOSection } from '@/components/blocks/DpLibrary/DpSEOSection';
import { DpSEOTitle } from '@/components/blocks/DpLibrary/DpSEOTitle';
import { DpSEOText } from '@/components/blocks/DpLibrary/DpSEOText';
import { DpCardIconInformation } from '@/components/blocks/DpLibrary/DpCardIconInformation';
import { DpCardIconInformationGrid } from '@/components/blocks/DpLibrary/DpCardIconInformationGrid';
import { DpBannersTwoAds } from '@/components/blocks/DpLibrary/DpBannersTwoAds';
import { DpInputTextField } from '@/components/blocks/DpLibrary/DpInputTextField';
import { DpButtonForm } from '@/components/blocks/DpLibrary/DpButtonForm';
import { DpTitleCustom } from '@/components/blocks/DpLibrary/DpTitleCustom';
import { DpVideo } from '@/components/blocks/DpLibrary/DpVideo';
import { DpButtonPhone } from '@/components/blocks/DpLibrary/DpButtonPhone';
import { DpButtonWhatsApp } from '@/components/blocks/DpLibrary/DpButtonWhatsApp';
import { DpBannerChildren, DpBannerForm } from '@/components/blocks/DpLibrary/DpBannerForm';
import { DpDepartmentCard } from '@/components/blocks/DpLibrary/DpDepartmentCard';
import { BenefitsGray, DpBenefitGray } from '@/components/blocks/BenefitsGray';
import { DpSelect } from '@/components/blocks/DpLibrary/DpSelect';
import { DpMiniCardCategory } from '@/components/blocks/DpLibrary/DpMiniCardCategory';
import { DpBenefitCoupon } from '@/components/blocks/DpBenefitCoupon';
import { CenterContainer } from '@/components/blocks/CenterContainer';
import { DpH2 } from '@/components/blocks/DpLibrary/DPText';
import { DpStripBenefit } from '@/components/blocks/DpLibrary/DpStripBenefit';
import { DpNextBenefit } from '@/components/blocks/DpLibrary/DpNextBenefit';
import { DpScrollContainer } from '@/components/blocks/ScrollContainer';
import { DpMarksSlider } from '@/components/blocks/DpLibrary/DpMarksSlider';
import { CarouselSlider } from '@/components/blocks/Carousel';
import { DpContentBenefits } from '@/components/blocks/DpLibrary/DpContentBenefits';
import { DpRenderDesktop, DpRenderMobile } from '@/components/blocks/DpLibrary/DpRender';
import {
	DpPopulateBlockMobile,
	DpPopulateBlock,
	DpPopulateCategory,
	DpPopulateLink,
} from '@/components/blocks/DpLibrary/DpPopulate';
import { DpGridCard, DpGridCards } from '@/components/blocks/DpLibrary/DpGridCard';
import {
	DpTabLink,
	DpTabLinkContent,
	DpTabLinkContentLink,
	DpTabLinksContainer,
} from '@/components/blocks/DpLibrary/DpTabsLinks';
import { DpButtonEmail } from '@/components/blocks/DpLibrary/DpButtonEmail';
import { DpContact } from '@/components/blocks/DpLibrary/DpContact';
import { DpSatisfactionForm } from '@/components/blocks/DpLibrary/DpSatisfactionForm';
import { DpCardMap } from '@/components/blocks/DpLibrary/DpCardMap';
import { DpDpValeForm } from '@/components/blocks/DpLibrary/DpDpValeForm';
import { DpButtonModalForm } from '@/components/blocks/DpLibrary/DpButtonModalForm';
import { DpParagraphCustom } from '@/components/blocks/DpLibrary/DpParagraphCustom';
import { DpPromo } from '@/components/blocks/DpLibrary/DpPromo';
import DpAutoHidden from '@/components/blocks/DpLibrary/DpAutoHidden';
import { DpCatalogEntryCarouselSeeMore } from '@/components/blocks/DpLibrary/DpCatalogEntryCarouselSeeMore';
import { DpInformativeFrame } from '@/components/blocks/DpLibrary/DpInformativeFrame';
import { DpBreadcrumbCardFrame } from '@/components/blocks/DpLibrary/DpBreadcrumbCardFrame';
import { DpBreadcrumbCard } from '@/components/blocks/DpLibrary/DpBreadcrumbCard';
import { DpBuenFinBannerAds } from '@/components/blocks/DpLibrary/DpBFBannerAds';
import { DpCardForm } from '@/components/blocks/DpLibrary/DpCardForm';
import { DpDeportesEntrenamientoBannersTwoAds } from '@/components/blocks/DpLibrary/DpDeportesEntrenamientoBannersTwoAds';
import { DpSEOFrameDeporteEntrenamiento } from '@/components/blocks/DpLibrary/DpSEOFrameDeporteEntrenamiento';
import { DpSEOSectionDeporteEntrenamiento } from '@/components/blocks/DpLibrary/DpSEOSectionDeporteEntrenamiento';
import { DpVideoWithBackground } from '@/components/blocks/DpLibrary/DpVideoWithBackground';
import { DpTitlesDistribuidor } from '@/components/blocks/DpLibrary/DpTitlesDistribuidor';
import { DpFooterLinks } from '@/components/blocks/DpLibrary/DpFooterLinks/indext';
import { DpFooterTerminos } from '@/components/blocks/DpLibrary/DpFooterTerminos';
import { DpContainer } from '@/components/blocks/DpContainer';
import { DpGridTendence } from '@/components/blocks/DpLibrary/DpGridTendence';
import { DpCardDistribuidor } from '@/components/blocks/DpLibrary/DpCardDistribuidor';
import { DpVideoDistribuidor } from '@/components/blocks/DpLibrary/DpVideoDistribuidor';
import { DpBenefitsDistribuidor } from '@/components/blocks/DpLibrary/DpBenefitsDistribuidor';
import { DpBenefitsContainer } from '@/components/blocks/DpBenefitsContainer';
import { DpGridCardFrame } from '@/components/blocks/DpLibrary/DpGridCardFrame';
import { DpBottomContainer } from '@/components/blocks/DpBottomContainer';
import { DpScrollTitle } from '@/components/blocks/DpLibrary/DpScrollTitle';
import { DpScrollSubtitle } from '@/components/blocks/DpLibrary/DpScrollSubtitle';
import { DpScrollHeader } from '@/components/blocks/DpLibrary/DpScrollHeader';
import { DpGridCardAD } from '@/components/blocks/DpLibrary/DpGridCardAd';
import { DpPopulateContainer } from '@/components/blocks/DpPopulateContaier';
import { DpFloatingCard } from '@/components/blocks/DpLibrary/DpFloatingCard';
import { DpTitleMobile } from '@/components/blocks/DpLibrary/DpTitleMobile';
import { DpFloatingWhatsApp } from '@/components/blocks/DpLibrary/DpFloatingWhatsApp';
import { DpFullContainer } from '@/components/blocks/DpLibrary/DpFullContainer';
import { DpMarksSliderTemp } from '@/components/blocks/DpLibrary/DpMarksSliderTemp';
import { DpAccordionSeason } from '@/components/blocks/DpAccordionSeason';
import {
	DpPlpDescription,
	DpPlpTitle,
	DpPlpTitleFrame,
} from '@/components/blocks/DpLibrary/DpPlpTitle';
import { DpAccordionHelpCenter } from '@/components/blocks/DpAccordionHelpCenter';
import {
	DpHelpCenterLi,
	DpHelpCenterOl,
	DpHelpCenterP,
	DpHelpCenterSubtitle,
	DpHelpCenterTitle,
	DpHelpCenterUl,
} from '@/components/blocks/DpHelpCenter';
import { DpCatalogEntryCarouselHeaderContent } from '@/components/blocks/DpLibrary/DpCatalogEntryCarouselHeader/parts/DpCatalogEntryCarouselHeaderContent';
import { FiraLive } from '@/components/blocks/DpLibrary/DpFiraLive';
import { CustomDivider } from '@/components/blocks/CustomDivider';
import { DpBreadcrumbTrail } from '@/components/blocks/DpLibrary/DpBreadcrumbTrail';
import { DpPopUpPromotion } from '@/components/blocks/DpLibrary/DpPopUpPromotion';
import { DpCardImage, DpGridImages } from '@/components/blocks/DpLibrary/DpGridImages';
import {
	DpRichContentBanner,
	DpRichContentDescription,
	DpRichContentFrame,
	DpRichContentGridAd,
	DpRichContentGridAds,
	DpRichContentTitle,
} from '@/components/blocks/DpLibrary/DpRichContent';
import { DpHeaderTemporalCategory } from '@/components/blocks/DpLibrary/DpHeaderTemporalCategory';
import { CountdownTimer } from '@/components/blocks/DpLibrary/CounterDown';
import { HelpCenter } from '@/components/content/HelpCenter';
import { DPGetRefoundPDF } from '@/components/content/DPGetRefoundPDF';
import {
	DpFooterAccordionLink,
	DpFooterAccordionLinkFrame,
} from '@/components/blocks/GroupAccordionPageLink';
import { DpFooterGroupLink, DpFooterGroupLinkFrame } from '@/components/blocks/GroupPageLink';
import {
	DpForm,
	DpFormButton,
	DpFormInput,
	DpFormInputHidden,
	DpCheckboxForm,
} from '@/components/blocks/DpLibrary/DpForm';
import {
	DpOrderConfirmationAction,
	DpOrderConfirmationButton,
	DpOrderConfirmationCard,
	DpOrderConfirmationContent,
	DpOrderConfirmationDescription,
	DpOrderConfirmationImg,
	DpOrderConfirmationTitle,
} from '@/components/blocks/DpOrderConfirmationCard';
import { DpSearchBanner } from '@/components/blocks/DpSearchBanner';
import { DpBenefit, DpBenefits } from '@/components/blocks/Benefits';
import { DpOfferChip, DpOfferChipGrid } from '@/components/blocks/DpOfferChip';
import {
	DpCookieDialog,
	DpCookieDialogActions,
	DpCookieDialogConfirm,
	DpCookieDialogDescription,
	DpCookieDialogLink,
	DpCookieDialogTitle,
} from '@/components/blocks/DpCookieDialog';
import {
	DpInformativeContainer,
	DpInformativeH1,
	DpInformativeH3,
	DpInformativeLi,
	DpInformativeOl,
	DpInformativeP,
	DpInformativeUl,
} from '@/components/blocks/DpInformative';

export const MUI_ELEMENTS: Record<string, OverridableComponent<any>> = {
	Box,
	Button,
	Container,
	Grid,
	Paper,
	Stack,
	List,
	ListItem,
};

export const SPECIAL_TAGS: Record<string, FC<any>> = {
	a: Linkable,
	button: DpButton,
	div: Box,
	img: Img,
	hr: CustomDivider,
	'dp-accordion': DpAccordion,
	'dp-accordion-season': DpAccordionSeason,
	'dp-accordion-help-center': DpAccordionHelpCenter,
	'dp-help-center-title': DpHelpCenterTitle,
	'dp-help-center-subtitle': DpHelpCenterSubtitle,
	'dp-help-center-ul': DpHelpCenterUl,
	'dp-help-center-ol': DpHelpCenterOl,
	'dp-help-center-li': DpHelpCenterLi,
	'dp-help-center-p': DpHelpCenterP,
	'dp-best-offer': DpBestOffer,
	'dp-button': DpButton,
	'dp-card-tendence': DpCardTendence,
	'dp-card-category': DpCardCategory,
	'dp-carousel-content': DpCarouselContent,
	'dp-mark': DpMark,
	'dp-blog-grid': DpBlogGrid,
	'dp-blog-card': DpBlogCard,
	'dp-border-refunds': DpBorderRefunds,
	'dp-plp-banner-ads': DpPlpBannerAds,
	'dp-banner-ads': DpBannerAds,
	'dp-banner-ads-text': DpBannerAdsText,
	'dp-article-container': DpArticleContainer,
	'dp-article-header': DpArticleHeader,
	'dp-article-header-back': DpArticleHeaderBack,
	'dp-article-header-category': DpArticleHeaderCategory,
	'dp-article-title': DpArticleTitle,
	'dp-article-text': DpArticleText,
	'dp-article-content-frame': DpArticleContentFrame,
	'dp-article-content': DpArticleContent,
	'dp-article-content-title': DpArticleContentTitle,
	'dp-article-card-grid': DpArticleCardGrid,
	'dp-article-card': DpArticleCard,
	'dp-article-card-text': DpArticleCardText,
	'dp-article-card-emphasis': DpArticleCardEmphasis,
	'dp-most-new': ContentMostNew,
	'dp-promotion-image': DpPromotionImage,
	'dp-banner-checkout': DpBannerCheckout,
	'dp-catalog-entry-carousel-header': DpCatalogEntryCarouselHeader,
	'dp-search-catalog-entry-carousel-header': DpCatalogEntryCarouselHeaderContent,
	'dp-product-grid-card': DpProductGridCard,
	'dp-titles': DpTitles,
	'dp-titles-distribuidor': DpTitlesDistribuidor,
	'dp-seo-frame': DpSEOFrame,
	'dp-seo-section': DpSEOSection,
	'dp-seo-title': DpSEOTitle,
	'dp-seo-text': DpSEOText,
	'dp-card-icon-information': DpCardIconInformation,
	'dp-card-icon-information-grid': DpCardIconInformationGrid,
	'dp-banners-two-ads': DpBannersTwoAds,
	'dp-input-text-field': DpInputTextField,
	'dp-button-form': DpButtonForm,
	'dp-title-custom': DpTitleCustom,
	'dp-checkbox-form': DpCheckboxForm,
	'dp-video': DpVideo,
	'dp-video-with-background': DpVideoWithBackground,
	'dp-fira-live': FiraLive,
	'dp-button-phone': DpButtonPhone,
	'dp-button-whats-app': DpButtonWhatsApp,
	'dp-button-email': DpButtonEmail,
	'dp-banner-form': DpBannerForm,
	'dp-form': DpForm,
	'dp-form-input': DpFormInput,
	'dp-form-input-hidden': DpFormInputHidden,
	'dp-form-checkbox': DpCheckboxForm,
	'dp-form-button': DpFormButton,
	'dp-department-card': DpDepartmentCard,
	'dp-benefits-gray': BenefitsGray,
	'dp-select': DpSelect,
	'dp-grid-card-frame': DpGridCardFrame,
	'dp-select-option': MenuItem,
	'dp-mini-card-category': DpMiniCardCategory,
	'dp-benefit-coupon': DpBenefitCoupon,
	'dp-content-center': CenterContainer,
	'dp-h2': DpH2,
	'dp-scroll-frame': DpScrollContainer,
	'dp-strip-benefit': DpStripBenefit,
	'dp-next-benefit': DpNextBenefit,
	'dp-marks-slider': DpMarksSlider,
	'dp-marks-slider-temp': DpMarksSliderTemp,
	'dp-carousel-slider': CarouselSlider,
	'dp-content-benefits': DpContentBenefits,
	'dp-render-mobile': DpRenderMobile,
	'dp-render-desktop': DpRenderDesktop,
	'dp-expandable-item': DpPopulateBlockMobile,
	'dp-populate-category': DpPopulateCategory,
	'dp-populate-link': DpPopulateLink,
	'dp-populate-block': DpPopulateBlock,
	'dp-grid-cards': DpGridCards,
	'dp-grid-card': DpGridCard,
	'dp-tab-link-container': DpTabLinksContainer,
	'dp-tab-link': DpTabLink,
	'dp-tab-link-content': DpTabLinkContent,
	'dp-tab-link-content-link': DpTabLinkContentLink,
	'dp-contact': DpContact,
	'dp-satisfaction-form': DpSatisfactionForm,
	'dp-card-map': DpCardMap,
	'dp-dpvale-form': DpDpValeForm,
	'dp-buttonmodal-form': DpButtonModalForm,
	'dp-paragraph-custom': DpParagraphCustom,
	'dp-promo': DpPromo,
	'dp-auto-hidden': DpAutoHidden,
	'dp-catalog-entry-carousel-see-more': DpCatalogEntryCarouselSeeMore,
	'dp-informative-frame': DpInformativeFrame,
	'dp-plp-breadcrumb-card-frame': DpBreadcrumbCardFrame,
	'dp-plp-breadcrumb-card': DpBreadcrumbCard,
	'dp-buenfin-banner-ads': DpBuenFinBannerAds,
	'dp-card-form': DpCardForm,
	'dp-deportes-entrenamiento-banners-two-ads': DpDeportesEntrenamientoBannersTwoAds,
	'dp-seo-frame-entrenamiento': DpSEOFrameDeporteEntrenamiento,
	'dp-seo-section-entrenamiento': DpSEOSectionDeporteEntrenamiento,
	'dp-footer-links': DpFooterLinks,
	'dp-footer-terminos': DpFooterTerminos,
	'dp-container': DpContainer,
	'dp-bottom-container': DpBottomContainer,
	'dp-grid-tendence': DpGridTendence,
	'dp-cards-distribuidor': DpCardDistribuidor,
	'dp-video-distribuidor': DpVideoDistribuidor,
	'dp-benefits-distribuidor': DpBenefitsDistribuidor,
	'dp-benefits-container': DpBenefitsContainer,
	'dp-scroll-title': DpScrollTitle,
	'dp-scroll-subtitle': DpScrollSubtitle,
	'dp-scroll-header': DpScrollHeader,
	'dp-grid-card-ad': DpGridCardAD,
	'dp-populate-container': DpPopulateContainer,
	'dp-floating-card': DpFloatingCard,
	'dp-title-mobile': DpTitleMobile,
	'dp-floating-whatsapp': DpFloatingWhatsApp,
	'dp-full-container': DpFullContainer,
	'dp-plp-title-frame': DpPlpTitleFrame,
	'dp-plp-title': DpPlpTitle,
	'dp-plp-description': DpPlpDescription,
	'dp-breadcrumb-trail': DpBreadcrumbTrail,
	'dp-pop-up-promotion': DpPopUpPromotion,
	'dp-grid-images': DpGridImages,
	'dp-card-image': DpCardImage,
	'dp-countdown-timer': CountdownTimer,
	'dp-rich-content-frame': DpRichContentFrame,
	'dp-rich-content-title': DpRichContentTitle,
	'dp-rich-content-description': DpRichContentDescription,
	'dp-rich-content-banner': DpRichContentBanner,
	'dp-rich-content-grid-ads': DpRichContentGridAds,
	'dp-rich-content-grid-ad': DpRichContentGridAd,
	'dp-header-temporal-category': DpHeaderTemporalCategory,
	'dp-help-center': HelpCenter,
	'dp-get-refound-pdf': DPGetRefoundPDF,
	'dp-footer-accordion-link-frame': DpFooterAccordionLinkFrame,
	'dp-footer-accordion-link': DpFooterAccordionLink,
	'dp-footer-group-link-frame': DpFooterGroupLinkFrame,
	'dp-footer-group-link': DpFooterGroupLink,
	'dp-banner-children': DpBannerChildren,
	'dp-order-confirmation-card': DpOrderConfirmationCard,
	'dp-order-confirmation-img': DpOrderConfirmationImg,
	'dp-order-confirmation-title': DpOrderConfirmationTitle,
	'dp-order-confirmation-description': DpOrderConfirmationDescription,
	'dp-order-confirmation-content': DpOrderConfirmationContent,
	'dp-order-confirmation-action': DpOrderConfirmationAction,
	'dp-order-confirmation-button': DpOrderConfirmationButton,
	'dp-search-banner': DpSearchBanner,
	'dp-benefits': DpBenefits,
	'dp-benefit': DpBenefit,
	'dp-benefits-gray-frame': BenefitsGray,
	'dp-benefit-gray': DpBenefitGray,
	'dp-offer-chip': DpOfferChip,
	'dp-offer-chip-grid': DpOfferChipGrid,
	'dp-cookie-dialog': DpCookieDialog,
	'dp-cookie-dialog-title': DpCookieDialogTitle,
	'dp-cookie-dialog-description': DpCookieDialogDescription,
	'dp-cookie-dialog-actions': DpCookieDialogActions,
	'dp-cookie-dialog-confirm': DpCookieDialogConfirm,
	'dp-cookie-dialog-link': DpCookieDialogLink,
	'dp-accordion-frame': DpAccordionFrame,
	'dp-accordion-summary': DpAccordionSummary,
	'dp-accordion-details': DpAccordionDetails,
	'dp-informative-container': DpInformativeContainer,
	'dp-informative-h1': DpInformativeH1,
	'dp-informative-h3': DpInformativeH3,
	'dp-informative-ul': DpInformativeUl,
	'dp-informative-ol': DpInformativeOl,
	'dp-informative-li': DpInformativeLi,
	'dp-informative-p': DpInformativeP,
};

export const TYPOGRAPHY_TAGS: Record<string, OverridableComponent<any>> = [
	'h1',
	'h2',
	'h3',
	'h4',
	'h5',
	'h6',
	'p:body1',
	'strong',
	'overline',
].reduce(
	(named, key) => ({
		...named,
		[key.split(':').at(0) || '']: (props: any) => (
			<Typography variant={key.split(':').at(-1)} {...props} />
		),
	}),
	{}
);
